var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-helper-components-3-resource-list",staticStyle:{"text-align":"left"}},[_c('DigitalCurrency14FrequentlyAskedQuestionsList'),_c('App3PleaseDonate',{staticClass:"mb-12"}),_c('App2ProjectReadme')],1)}
var staticRenderFns = []

export { render, staticRenderFns }